import moment from "moment";

export const validateZero = (value, type) => {
  if (!value) return "";
  if (Number(value) === 0) return "";
  else return type?.replace("xxx", value);
};

export const formatDate = (date) => {
  const newDate = moment(date);
  if (!newDate?.isValid()) return "";
  return newDate.format("LL");
};
